import React from 'react';
import {
  FormControl,
  FormHelperText,
  Grid,
  InputLabel,
  MenuItem,
  TextField,
  Typography,
} from '@mui/material';
import { Controller, useFormContext } from 'react-hook-form';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';

import CustomPanel from '../../../../../common/CustomPanel';
import { renderHiddenInput } from '../../../../../common/FormHiddenField';
import OutlinedSelect from '../../../../../common/OutlinedSelect';
import UploadImage from '../UploadImage';
import { selectCashRanges } from '../../../Application/utils/selectors';

function calculateDues(ranges, total) {
  const range = ranges.find((r) => total >= r.min && total <= r.max);
  let result = range.quotes.map((q) => ({
    quota: q,
    amount: Math.round((total / q) * 100) / 100,
    dueText: `${q} Cuota(s) de ${Math.round((total / q) * 100) / 100}`,
  }));
  return result;
}

export default function CashPayment({ total }) {
  const { control, setValue, clearErrors, formState: { errors } } = useFormContext();
  const ranges = useSelector(selectCashRanges);
  const dues = calculateDues(ranges, total);

  /** Function called by UploadImage component, allow to set
   * image path on image value of react hook form.
   * @param data image data.
   * */
  const onChangeImage = (data) => {
    if (data) {
      clearErrors([
        'cashPayment.image',
        'cashPayment.imageName',
      ]);
      setValue('cashPayment.image', data?.dataURL);
      setValue('cashPayment.imageName', data?.file?.name);
    }
  };

  const onRemoveImage = (onRemove) => {
    onRemove();
    setTimeout(() => {
      setValue('cashPayment.image', '');
      setValue('cashPayment.imageName', '');
    }, 500);
  };

  return (
    <>
      <Grid item xs={12}>
        <CustomPanel withoutTitle subtitle="Transferencia / Deposito">
          <Grid container>
            <Grid item xs={12} sm={6}>
              <UploadImage
                onChangeImage={onChangeImage}
                onRemoveImage={onRemoveImage}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <Grid container direction="column">
                <Grid item>
                  <Typography>
                    Selecciona una imagen de evidencia
                    de la transferencia o deposito.
                  </Typography>
                </Grid>
                <Grid item>
                  <Controller
                    name="cashPayment.imageName"
                    control={control}
                    defaultValue=""
                    render={({ field }) => (
                      <TextField
                        {...field}
                        fullWidth
                        label="IMAGEN"
                        InputProps={{ readOnly: true }}
                        error={errors.cashPayment?.hasOwnProperty('imageName')}
                        helperText={errors.cashPayment?.imageName?.message}
                      />
                    )}
                  />
                  <Controller
                    name="cashPayment.image"
                    control={control}
                    defaultValue=""
                    render={renderHiddenInput}
                  />
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </CustomPanel>
      </Grid>
      <Grid item xs={12} sm={6}>
        <FormControl
          fullWidth
          error={errors.cashPayment?.hasOwnProperty('dues')}
        >
          <InputLabel id="dues-select">PAGO CUOTAS</InputLabel>
          <Controller
            name="cashPayment.dues"
            control={control}
            defaultValue=""
            render={({ field: { ref, ...fieldProps } }) => (
              <OutlinedSelect {...fieldProps} inputRef={ref} labelId="dues-select" label="PAGO CUOTAS">
                <MenuItem value=""><em>Seleccione..</em></MenuItem>
                {dues?.map((d, index) => (
                  <MenuItem
                    key={index}
                    value={JSON.stringify(d)}
                  >
                    {d.dueText}
                  </MenuItem>
                ))}
              </OutlinedSelect>
            )}
          />
          <FormHelperText>
            {errors.cashPayment?.dues?.message}
          </FormHelperText>
        </FormControl>
      </Grid>
    </>
  );
}

CashPayment.propTypes = {
  total: PropTypes.number.isRequired,
};
